import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Next Course
 */
const NextCourse = (() => {
  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    LINK: '> a',
    MORE: '.course-more-wrap'
  };

  /**
   * NextCourse
   *
   * @class
   * @augments HtmlElement
   */
  class NextCourse extends HtmlElement {
    constructor($element, nextCourses) {
      super($element);

      this._nextCourses = nextCourses;
    }

    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$link = this.$element.find(Selector.LINK);
      this._$moreButton = this.$element.find(Selector.MORE);
    }

    /**
     * Sets the height
     *
     * @param { int } height
     * @return void
     */
    setHeight(height) {
      this._$link.css('height', height);
    }
  }

  return NextCourse;
})();

export default NextCourse;
